import {
  FETCH_YOUR_SAVINGS_HUB_REQUEST,
  FETCH_YOUR_SAVINGS_HUB_SUCCESS,
  FETCH_YOUR_SAVINGS_HUB_ERROR,
} from '../actions/yourSavingsHub';

export const initialState = {
  data: {
    numberOfCoupons: 0,
    savingsForCoupons: 0,
    pricePromiseVoucherCode: null,
    pricePromiseVoucherValue: null,
    scribeContent: {
      docNo: null,
      docVersionNo: null,
      docTitle: '',
      graphicBanner1: {
        docNo: null,
        docVersionNo: null,
        docModel: '',
        docTitle: '',
        imageSrc: '',
        showOnMobile: null,
      },
      graphicBanner2: {
        docNo: null,
        docVersionNo: null,
        docModel: '',
        docTitle: '',
        imageSrc: '',
        showOnMobile: null,
      },
      productsCarousel1: {
        sections: [],
      },
      productsCarousel2: {
        sections: [],
      },
      productsCarousel3: {
        sections: [],
      },
    },
  },
  loading: false,
  error: null,
};

export default function yourSavingsHub(state = initialState, action) {
  switch (action.type) {
    case FETCH_YOUR_SAVINGS_HUB_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_YOUR_SAVINGS_HUB_SUCCESS: {
      const newState = {
        ...state,
        data: {
          ...state.data,
          ...action.data,
          scribeContent: {
            ...state.data.scribeContent,
            ...action.data.scribeContent,
            productsCarousel1: {
              ...state.data.scribeContent.productsCarousel1,
              ...action.data.scribeContent.productsCarousel1,
            },
            productsCarousel2: {
              ...state.data.scribeContent.productsCarousel2,
              ...action.data.scribeContent.productsCarousel2,
            },
            productsCarousel3: {
              ...state.data.scribeContent.productsCarousel3,
              ...action.data.scribeContent.productsCarousel3,
            },
          },
        },
        loading: false,
        error: null,
      };
      return newState;
    }
    case FETCH_YOUR_SAVINGS_HUB_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
}
